var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "v-layout",
        { attrs: { row: "", "justify-center": "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                fullscreen: "",
                "hide-overlay": "",
                transition: "dialog-bottom-transition"
              },
              model: {
                value: _vm.show,
                callback: function($$v) {
                  _vm.show = $$v
                },
                expression: "show"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "CabeceraModalCrear",
                    {
                      attrs: { titulo: "Agregar Calendario" },
                      on: { cerrar: _vm.handleCerrar }
                    },
                    [
                      _c("GuardarButton", {
                        attrs: {
                          disabled: _vm.form.isDirty ? _vm.hasErrors : false
                        },
                        on: { click: _vm.handleGuardarClick }
                      })
                    ],
                    1
                  ),
                  _c(
                    "ContenidoModal",
                    [
                      _c("CalendarioForm", {
                        attrs: { mostrarActivo: false },
                        on: { change: _vm.handleFormChange }
                      }),
                      _c("Confirmation", {
                        attrs: {
                          show: _vm.dialogConfirmacionGuardar,
                          titulo: _vm.$t("mensajes.crud.agregar.titulo", {
                            entidad: "Calendario"
                          }),
                          mensaje: _vm.$t("mensajes.crud.agregar.mensaje", {
                            entidad: "el Calendario"
                          }),
                          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
                          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
                        },
                        on: {
                          modalConfirmationEmit: function($event) {
                            return _vm.confirmCallback($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }